import Vue from 'vue';
import vMultiselectListbox from 'vue-multiselect-listbox';

Vue.component('v-multiselect-listbox', vMultiselectListbox);
